"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOKEN_DETECTION_COOKIE = void 0;
exports.tokenDetection = tokenDetection;
const server_1 = require("next/server");
const helpers_1 = require("../helpers");
exports.TOKEN_DETECTION_COOKIE = "SHOW_SIGN_IN";
function tokenDetection(req) {
    const hasToken = !!req.cookies.get("jwt")?.value;
    const hasTokenDetectionCookie = !!req.cookies.get(exports.TOKEN_DETECTION_COOKIE)?.value;
    if (hasToken && !hasTokenDetectionCookie) {
        const response = server_1.NextResponse.next();
        response.cookies.set(exports.TOKEN_DETECTION_COOKIE, "true", {
            expires: new Date(Date.now() + helpers_1.ONE_MONTH_IN_MS),
            sameSite: "none",
            secure: true,
            httpOnly: false,
        });
        return response;
    }
    if (!hasToken && hasTokenDetectionCookie) {
        const response = server_1.NextResponse.next();
        response.cookies.delete(exports.TOKEN_DETECTION_COOKIE);
        return response;
    }
    return;
}
//# sourceMappingURL=tokenDetection.js.map